import _values from 'lodash/values';

const sharingUrlValues = {
  EXPERIENCE_URL: 'ctx:smarturl',
  CUSTOM_URL:     'url',
};

sharingUrlValues.ALL = _values(sharingUrlValues);

export default sharingUrlValues;
